export const getTabName = (item) => {
  if (item.clientName !== null && item.clientName !== "")
    return item.clientName;
  return item.clientRef;
};
